export default [
    {
        email:"admin@gmail.com",
        password:"admin"
    }
];
